export const config = {
  account: {
    ampReaderId: process.env.NEXT_PUBLIC_AMP_READER_ID ?? "",
    application: process.env.NEXT_PUBLIC_APPLICATION ?? "",
    authCallbackUrl: process.env.NEXT_PUBLIC_AUTH_CALLBACK_URL ?? "",
    authDestination: process.env.NEXT_PUBLIC_SITE_URL ?? "",
    cookieDomain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN ?? "",
    debugLog: process.env.NODE_ENV !== "production",
    mixPanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? "",
    recaptchaContainerId: process.env.NEXT_PUBLIC_RECAPTCHA_CONTAINER_ID ?? "",
    recaptchaSiteKey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? "",
    registerCallbackUrl: process.env.NEXT_PUBLIC_REGISTER_CALLBACK_URL ?? "",
    scmpAccountHost: process.env.NEXT_PUBLIC_SCMP_ACCOUNT_HOST ?? "",
    sendWelcomeEmail: process.env.NEXT_PUBLIC_SEND_WELCOME_EMAIL === "true",
    userPicPrefix: process.env.NEXT_PUBLIC_USER_PROFILE_PIC_PREFIX ?? "",
  },
  advertisement: {
    amazonPublisherService: {
      bidTimeout: 1.5e3,
      publisherId: "6480e4f8-95c9-4189-ad8f-2c8a76bcf0ab",
    },
    configId: process.env.NEXT_PUBLIC_ADVERTISEMENT_CONFIG_ID ?? "",
    googlePublisherTag: {
      adUnitPrefix: process.env.NEXT_PUBLIC_GPT_AD_UNIT_PREFIX ?? "",
      networkId: "8134",
    },
    indexExchangeWrapper: {
      scriptUrl: process.env.NEXT_PUBLIC_INDEX_EXCHANGE_WRAPPER_SCRIPT_URL ?? "",
    },
    prebid: {
      googleAnalyticsProfileId: process.env.NEXT_PUBLIC_PREBID_GA_PROFILE_ID,
    },
    viewabilityService: {
      apiKey: process.env.NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_API_KEY ?? "",
      url: process.env.NEXT_PUBLIC_ADVERTISEMENT_VIEWABILITY_SERVICE_URL ?? "",
    },
  },
  app: {
    android: {
      name: "SCMP",
      package: "com.scmp.newspulse" /* Cspell: disable-line */,
    },
    ios: {
      name: "SCMP",
      storeId: "623201967",
    },
  },
  corporateSubscriber: {
    host: process.env.NEXT_PUBLIC_CORPORATE_SUBSCRIBER_HOST ?? "",
  },
  date: {
    defaultFormat: "d MMM yyyy - h:mma",
    defaultTimeZone: "Asia/Hong_Kong",
  },
  domain: {
    scmp: process.env.NEXT_PUBLIC_DOMAIN_SCMP ?? "",
  },
  elasticsearch: {
    apiKey: process.env.NEXT_PUBLIC_ELASTICSEARCH_API_KEY ?? "",
    host: process.env.NEXT_PUBLIC_ELASTICSEARCH_HOST ?? "",
  },
  features: {
    enableInfiniteScroll: process.env.NEXT_PUBLIC_FEATURES_ENABLE_INFINITE_SCROLL === "true",
    enablePaywall: process.env.NEXT_PUBLIC_FEATURES_ENABLE_PAYWALL === "true",
  },
  firebase: {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? "",
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID ?? "",
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? "",
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_URL ?? "",
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? "",
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? "",
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? "",
  },
  general: {
    aiEngineFallbackHost: process.env.NEXT_PUBLIC_AI_ENGINE_FALLBACK_HOST ?? "",
    aiEngineHost: process.env.NEXT_PUBLIC_AI_ENGINE_HOST ?? "",
    bypassMigrateRouteChecking: process.env.NEXT_PUBLIC_BYPASS_MIGRATE_ROUTE_CHECKING === "true",
    cdn: {
      enabled: process.env.NEXT_PUBLIC_USE_CDN === "true",
      host: process.env.NEXT_PUBLIC_OSS_HOST ?? "",
    },
    commitSha: process.env.NEXT_PUBLIC_COMMIT_SHA ?? "",
    disableClientSideRouting: process.env.NEXT_PUBLIC_DISABLE_CLIENT_SIDE_ROUTING === "true",
    env: process.env.NEXT_PUBLIC_ENV_SLUG ?? "",
    readingHistoryHost: process.env.NEXT_PUBLIC_READING_HISTORY_HOST ?? "",
    reverseProxyHost: process.env.NEXT_PUBLIC_REVERSE_PROXY_HOST ?? "",
    rosettaHost: process.env.NEXT_PUBLIC_ROSETTA_HOST ?? "",
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL ?? "",
    userFollowHost: process.env.NEXT_PUBLIC_USER_FOLLOW_HOST ?? "",
    userTypeHost: process.env.NEXT_PUBLIC_USER_TYPE_HOST ?? "",
  },
  google: {
    clientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "",
  },
  googleAnalytics: {
    profileId: process.env.NEXT_PUBLIC_GA_PROFILE_ID ?? "",
  },
  googleTagManager: {
    containerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID ?? "",
  },
  graphql: {
    contentService: {
      apiKey: process.env.NEXT_PUBLIC_CONTENTSERVICE_API_KEY ?? "",
      host: process.env.NEXT_PUBLIC_CONTENTSERVICE_HOST ?? "",
    },
    drupal: {
      apiKey: process.env.NEXT_PUBLIC_DRUPAL_API_KEY ?? "",
      host: process.env.NEXT_PUBLIC_DRUPAL_HOST ?? "",
    },
  },
  locationService: {
    apiKey: process.env.NEXT_PUBLIC_LOCATION_SERVICE_API_KEY ?? "",
    url: process.env.NEXT_PUBLIC_LOCATION_SERVICE_URL ?? "",
  },
  rosetta: {
    // TODO: better rename the service name to location or accept full path instead of using the api url prefix only
    // refs: https://project.scmp.tech/product/web/npm/rosetta-sdk/-/blob/master/rosetta-sdk/src/utils/contentService.js#L40
    contentService: {
      apiKey: process.env.NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_API_KEY ?? "",
      apiUri: process.env.NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_HOST ?? "",
      environment: process.env.NEXT_PUBLIC_ROSETTA_CONTENTSERVICE_ENVIRONMENT ?? "",
    },
    drupal: {
      apiKey: process.env.NEXT_PUBLIC_ROSETTA_DRUPAL_API_KEY ?? "",
      apiUri: process.env.NEXT_PUBLIC_DRUPAL_HOST ?? "",
      environment: process.env.NEXT_PUBLIC_ROSETTA_DRUPAL_ENVIRONMENT ?? "",
    },
    piano: {
      apiUri: process.env.NEXT_PUBLIC_ROSETTA_PIANO_API_URL ?? "",
      applicationId: process.env.NEXT_PUBLIC_ROSETTA_PIANO_APPLICATION_ID ?? "",
      environment: process.env.NEXT_PUBLIC_ROSETTA_PIANO_ENVIRONMENT ?? "",
    },
    subscribeHost: process.env.NEXT_PUBLIC_ROSETTA_HOST ?? "",
    subscribeTemplateHost: process.env.NEXT_PUBLIC_SUBSCRIPTION_TEMPLATE ?? "",
  },
  sentry: {
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN ?? "",
  },
  serviceWorker: {
    cacheVersion: process.env.NEXT_PUBLIC_SERVICE_WORKER_CACHE_VERSION ?? "",
    notificationGaProfileId: process.env.NEXT_PUBLIC_GA_PUSH_NOTIFICATION_PROFILE_ID ?? "",
  },
  social: {
    api: {
      host: process.env.NEXT_PUBLIC_SOCIAL_API_HOST ?? "",
    },
    facebook: {
      appId: "282931841805811",
      likeUrl:
        "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fscmp%2F&width=86&layout=button_count&action=like&size=small&share=false&height=21&appId=282931841805811",
    },
    twitter: {
      accountName: "SCMPNews",
    },
  },
} as const;
